/* eslint-disable react/prop-types */
'use client';

import { ErrorCardWithLogin } from '@commerce-webcomponents/ui-composite';
import { Errors } from '@commerce-webcomponents/ui';
import { useNextgenRouter, useSession } from '@nextgen-web-framework/all';
import { useEffect, useState } from 'react';
import { ProtectedRouteProps } from './types/propsTypes';
import { checkRoleAccessibility } from 'utils/auth';
import { useRolesConfig, UserRole } from 'utils/rolesConfig';

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles, handleUnauthorizedAction }) => {
  const router = useNextgenRouter();
  const [isAuthorized, setIsAuthorized] = useState<boolean>();
  const { isRegistered, isABO, isMember, isEmployee } = useSession();
  const { UserRole, Groups, UserGroups } = useRolesConfig();
  const onActionClick = () => {
    router.push('/');
  };

  const getUserRole = (): UserRole => {
    if (isABO()) {
      return UserRole.ABO;
    }
    if (isRegistered()) {
      return UserRole.REGISTERED;
    }
    if (isMember()) {
      return UserRole.MEMBER;
    }

    if (isEmployee()) {
      return UserRole.EMPLOYEE;
    }

    return UserRole.ANONYMOUS;
  };

  useEffect(() => {
    const role = getUserRole();
    const result = checkRoleAccessibility(allowedRoles, role, Groups, UserGroups);
    setIsAuthorized(result);
  }, [allowedRoles]);
  if (isAuthorized === undefined) {
    return null;
  }

  if (isAuthorized) {
    return children;
  }

  if (handleUnauthorizedAction) {
    handleUnauthorizedAction();
    return null;
  }

  return <ErrorCardWithLogin type={Errors.Restricted} onActionClick={onActionClick} />;
};

export default ProtectedRoute;
